import Typography from '@mui/material/Typography';
import ConhrlyTable from './ConhrlyTable';
import { getAcisData, windchill, heatindex, setupFilters, passesFilter } from '../js/dataAccessRoutines';
import { valSmry } from '../js/utilityRoutines';

// Extreme runs processing //

const traceValue = 0.001;

const sendResults = (results, setResult) => {
  if (results) {
      const code = (
        <ConhrlyTable 
			tabledata = {results.tabledata}
			sumObs = {results.sumObs}
			sumMiss = {results.sumMiss}
			userParams = {results.userParams}
			stnName = {results.stnName}
        />
      );
      setResult(code)
  } else {
    setResult("")
  }
}

const formatResults = (valueHistogram, userParams) => {
	var first, tabledata=[];
	const valueKeys = Object.keys(valueHistogram).sort((a, b) => parseFloat(b)-parseFloat(a));
	if (valueKeys.length > 0) {
		let sumrecs = 0;
		valueKeys.forEach((val) => {
			first = true;
			if (sumrecs < userParams.numrec) {
				valueHistogram[val].forEach((dt) => {
					sumrecs += 1;
					tabledata.push({
						index: sumrecs,
						rank: first ? sumrecs : "-",
						val: val, 
						dt: dt
					})
					first = false;
				})
			}
		})
	} else {
		tabledata.push({
			index: sumrecs,
			rank: "-",
			val: "--- No runs met definition ---", 
			dt: "-"
		})
	}
  return tabledata
}

const processData = (res, userParams, endtime) => {
	var val, runlength = 0, runend = null;
	const stnName = res.meta.name + ", " + res.meta.state;
	const filters = setupFilters(userParams);
	const noVal = 'na'  //code for when wind chill or heat index input outside range
	const endmmdd = [(endtime.month+1).toString().padStart(2, '0'), endtime.day.toString().padStart(2, '0')].join("-");
	const discontinuous = userParams.toFilterMonth !== 12 || userParams.toFilterDay !== 31 ||
		userParams.fromFilterMonth !== 1 || userParams.fromFilterDay !== 1;
	// save run and reset counters
	const saveAndReset = (valueHistogram) => {
		if (runlength > 0) {
			if (!valueHistogram.hasOwnProperty(runlength)) {
				valueHistogram[runlength] = [];
			}
			valueHistogram[runlength].unshift(runend);		// add to beginning of array so most recent are first
			runlength = 0;
			runend = null;
		}
	}

	//initializations
	let sumObs = 0;
	let sumMiss = 0;
	let valueHistogram = {};
	//process
	res.data.forEach((results, i) => {
		// date filter
		if (passesFilter(results[0], filters)) {
			const mmdd = results[0].slice(5, 10);
			const hh = parseInt(results[0].slice(11, 13))
			if (userParams.variable === 'wchill') {
				val = windchill(results[1], results[2], noVal)
			} else if (userParams.variable === 'htindx') {
				val = heatindex(results[1], results[2], noVal)
			} else if (userParams.variable === 'pcpn' && results[1] === "T") {
				val = traceValue	//trace value
			} else {
				val = results[1]
			}
			
			if (!["M",noVal].includes(val)) {
				const rval = parseFloat(val);
                const cntresult = valSmry(rval, userParams, traceValue);
                if (cntresult === 1) {
					runlength += 1;
					runend = results[0]
				} else {
					// run terminated by value outside threshold
					saveAndReset(valueHistogram);
				}
				sumObs += 1;
			} else {
				// run terminated by missing or not available value
				saveAndReset(valueHistogram);
				sumMiss += 1
			}
			// if there is a day filter and it's the end of the filter, terminate and save run
			if (discontinuous && mmdd === endmmdd && hh === 0) {
				saveAndReset(valueHistogram);
			}
		}
	})
	saveAndReset(valueHistogram);	// terminate any in progress run at end of data
	const tabledata = formatResults(valueHistogram, userParams)
	return {tabledata, sumObs, sumMiss, stnName}
}

export function processConhrly(userParams, setResult, hourlyVx) {
	const sid = userParams.sid;
	const network = sid.indexOf(" ") > 0 ? sid.split(" ")[1] : 'icao';
	// some variables need to be calculated from others; get what's needed
	var elems;
	if (userParams.variable === 'wchill') {
		elems = [ {vX: hourlyVx[network]['temp'], interval: [0,0,0,1], duration: 1}, {vX: hourlyVx[network]['wspd'], interval: [0,0,0,1], duration: 1} ]
	} else if (userParams.variable === 'htindx') {
		elems = [ {vX: hourlyVx[network]['temp'], interval: [0,0,0,1], duration: 1}, {vX: hourlyVx[network]['rhum'], interval: [0,0,0,1], duration: 1} ]
	} else {
		elems = [ {vX: hourlyVx[network][userParams.variable], interval: [0,0,0,1], duration: 1} ]
	}
	const starttime = userParams.fromDate.hour(1)
	const sdate = [starttime.year(),starttime.month()+1,starttime.date(),starttime.hour()] || [2023,12,1,1];
	// end hour 24, which is hour 0 the next day
	const endtime = userParams.toDate.hour(23).add(1, "hours")
	const edate = [endtime.year(),endtime.month()+1,endtime.date(),endtime.hour()] || [2024,1,1,0];

	const acisParams = {
			sid: sid,
			sDate: sdate,
			eDate: edate,
			elems: elems,
	}
	getAcisData(acisParams)
	.then(res => {
		const results = processData(res, userParams, endtime);
		sendResults({...results, userParams}, setResult)
	})
	.catch(error =>  { 
		console.log("Data retrieval error: " + error); 
		setResult((
			<Typography sx={{color: "red"}}>
				Error processing request
			</Typography>
		))
	})
}